import { useAuth } from "@/contexts/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { CLOUD_RUN_URL } from "@/services/shared";

export const useProjectFile = (fileId: string | null) => {
  const { session } = useAuth();
  const { projectId } = useParams<{ projectId: string }>();
  const { data, isLoading, error } = useQuery({
    queryKey: ["signed-url", projectId, fileId],
    queryFn: async () => {
      const params = new URLSearchParams({ file_id: fileId! });
      const res = await fetch(
        `${CLOUD_RUN_URL}/api/projects/${projectId}/files/signed-url?${params.toString()}`,
        {
          headers: session?.access_token
            ? { Authorization: `Bearer ${session.access_token}` }
            : undefined,
        },
      );
      if (!res.ok) {
        let message = "Failed to get signed URL";
        try {
          const text = await res.text();
          try {
            const body = JSON.parse(text);
            message = body?.error || body?.message || message;
          } catch {
            message = text || message;
          }
        } catch {
          // ignore read errors
        }
        throw new Error(message);
      }
      return (await res.json()) as { url: string; isSharePoint?: boolean };
    },
    enabled: !!projectId && !!fileId && !!session?.access_token,
    staleTime: 1000 * 60 * 5,
    retry: 0,
  });

  return { url: data?.url, isLoading, error };
};
